<template>
    <div style="width:100%">
      <v-row no-gutters>
          <v-col cols="12" md="6">
              <v-autocomplete v-model="logs_fraude.tipofraude_id" item-text="descripcion" item-value="id" :items="items.items_fraudetipo" :rules="[rules.requerido]" :color="colores.secundario" label='* TIPO DE FRAUDE' autocomplete="off"></v-autocomplete>
          </v-col>
      </v-row>
      <v-row no-gutters>
          <v-col cols="12">
              <v-autocomplete v-model="logs_fraude.modalidad_id" item-text="descripcion" item-value="id" :items="items.items_fraudemodalidad" :rules="[rules.requerido]" :color="colores.secundario" label='* MODALIDAD DE FRAUDE' autocomplete="off"></v-autocomplete>
          </v-col>
      </v-row>
      <v-row no-gutters>
          <v-col cols="12" md="6" class="pr-1">
            <v-text-field v-model="logs_fraude.monto_reclamado" @focus="evento_focus1" @blur="evento_blur1" label='MONTO RECLAMADO' :rules="[rules.requerido]" autocomplete="off" :color="colores.secundario" maxlength="20" counter="20"></v-text-field>
          </v-col>
          <v-col cols="12" md="6" class="pr-1">
            <v-text-field v-model="logs_fraude.modo_reconocido" @focus="evento_focus2" @blur="evento_blur2" label='MONTO RECONOCIDO' :rules="[rules.requerido]" autocomplete="off" :color="colores.secundario" maxlength="20" counter="20"></v-text-field>
          </v-col>
      </v-row>
      <v-row no-gutters>
          <v-col cols="12" md="6" class="pr-1">
            <span class="red--text text-h6">{{ errores.fraudes.monto_reclamado }}</span>
          </v-col>
          <v-col cols="12" md="6" class="pr-1">
            <span class="red--text text-h6">{{ errores.fraudes.modo_reconocido }}</span>
          </v-col>
      </v-row>
    </div>

</template>
<script>
import recFunciones from '@/js/rec_funciones.js'
export default {
  name: 'lectura_form_fraudeComponent',
  components: {
  },
  mixins: [recFunciones],
  props: ['colores', 'registro', 'logs_fraude', 'rules', 'items', 'errores'],
  data: () => ({
  }),
  created () {
  },
  methods: {
    evento_focus1 () {
      // entro al input texto
      const txt = this.logs_fraude.monto_reclamado
      this.logs_fraude.monto_reclamado = this.rec_function_replaceall(txt, ',', '')
    },
    evento_focus2 () {
      // entro al input texto
      const txt = this.logs_fraude.modo_reconocido
      this.logs_fraude.modo_reconocido = this.rec_function_replaceall(txt, ',', '')
    },
    evento_blur1 () {
      var txt = this.logs_fraude.monto_reclamado
      this.logs_fraude.monto_reclamado = this.rec_function_numberWithCommas(txt, ',')
    },
    evento_blur2 () {
      var txt = this.logs_fraude.modo_reconocido
      this.logs_fraude.modo_reconocido = this.rec_function_numberWithCommas(txt, ',')
    }
  }
}
</script>
